import { Action, createReducer, on } from '@ngrx/store';
import * as AllocateConsumerFromBillingitemWizardActions from './actions';
import { State, initialState } from './state';

export const allocateConsumerFromBillingitemWizardFeatureKey = 'allocateConsumerFromBillingitemWizardV26';

const allocateConsumerFromBillingitemWizardReducer = createReducer(
  initialState,

  on(AllocateConsumerFromBillingitemWizardActions.selectInitStep, (state, { initStep }) => ({
    ...state,
    initStep,
    datesStep: { activationDate: null, deactivationDate: null },
  })),
  on(AllocateConsumerFromBillingitemWizardActions.selectBillingitemStep, (state, { billingitemStep }) => ({
    ...state,
    initStep: {
      ...state.initStep,
      billingitemId: billingitemStep.billingitemId,
      productfamilyId: billingitemStep.billingitemProductFamilyId,
      catalog: billingitemStep,
      requiresDisplayProduct: billingitemStep.billingitemRequiresDisplayProduct,
      isDisplayProduct: billingitemStep.billingitemIsDisplayProduct,
    },
  })),
  on(AllocateConsumerFromBillingitemWizardActions.selectDatesStep, (state, { datesStep }) => ({
    ...state,
    datesStep,
  })),
  on(AllocateConsumerFromBillingitemWizardActions.selectUsersStep, (state, { consumerDesksStep, reuseAllocationStep }) => ({
    ...state,
    consumerDesksStep: [...consumerDesksStep],
    reuseAllocationStep: [...reuseAllocationStep],
  })),
  on(AllocateConsumerFromBillingitemWizardActions.selectMiscellaneousStep, (state, { miscellaneousStep }) => ({
    ...state,
    miscellaneousStep,
  })),
  on(AllocateConsumerFromBillingitemWizardActions.exitAllocateConsumerFromBillingitemWizard, (state) => ({
    ...state,
    initStep: null,
    datesStep: null,
    consumerDesksStep: null,
    reuseAllocationStep: null,
    miscellaneousStep: null,
  })),
  on(AllocateConsumerFromBillingitemWizardActions.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    datesStep: null,
    consumerDesksStep: null,
    reuseAllocationStep: null,
    miscellaneousStep: null,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return allocateConsumerFromBillingitemWizardReducer(state, action);
}
